import { render, staticRenderFns } from "./fikria_view.vue?vue&type=template&id=2eb61800&scoped=true"
import script from "./fikria_view.vue?vue&type=script&lang=js"
export * from "./fikria_view.vue?vue&type=script&lang=js"
import style0 from "./fikria_view.vue?vue&type=style&index=0&id=2eb61800&prod&lang=css"
import style1 from "./fikria_view.vue?vue&type=style&index=1&id=2eb61800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb61800",
  null
  
)

export default component.exports